import { useEffect } from 'react';
import { ClientFlags, SaveClientFlags } from '@sdk/authentication/types';

type Props = {
  clientFlags: ClientFlags;
  saveClientFlags: SaveClientFlags;
};

const useLaborCostTabVisited = ({ clientFlags, saveClientFlags }: Props) => {
  useEffect(() => {
    if (!clientFlags.hasVisitiedLaborCostSettingsTab) {
      saveClientFlags({ flags: { hasVisitiedLaborCostSettingsTab: true } });
    }
  }, [clientFlags.hasVisitiedLaborCostSettingsTab, saveClientFlags]);
};

export default useLaborCostTabVisited;
